import React, { useCallback, useEffect, useRef, useState } from "react";
import "../assets/public/Navbar.css"; // Create a separate CSS file for styling
import logo from '../assets/images/IIT-Bhubaneswar-IIT-BBS-768x711.png';
import { useNavigate } from 'react-router-dom';
import { useAuthentication } from "../providers/authentication";

const Navbar = () => {
  const navigate = useNavigate();
  const { user, googleLogin, googleLogout, loading, updateLoading } = useAuthentication();
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMenuVisible, setIsMenuVisible] = useState(false); // State for sliding menu
  const dropdownRef = useRef(null);
  const menuRef = useRef(null);  // Reference for the sliding menu
  const timeoutRef = useRef(null); // Ref for timeout

  const handleNavigate = useCallback((page) => {
    navigate(page);
    setIsMenuVisible(false); // Close the sliding menu after navigating to a page
  }, [navigate]);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible); // Toggle dropdown visibility
  };

  const toggleMenu = () => {
    setIsMenuVisible(!isMenuVisible); // Toggle sliding menu visibility
  };

  const handleAdminLogin = () => {
    if (!loading) {
      updateLoading(true);
      googleLogin();
    }
  }

  const handleLogout = () => {
    googleLogout();
    console.log("logging out");
    console.log(user);
  }

  // Close the dropdown if clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownVisible(false);
      }
      // Close the menu if clicking outside
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Handle dropdown visibility on mouse enter and leave
  const handleMouseEnter = () => {
    clearTimeout(timeoutRef.current); // Clear any existing timeout
    setIsDropdownVisible(true); // Show dropdown
  };

  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setIsDropdownVisible(false); // Hide dropdown after 1 second
    }, 1000);
  };

  return (
    <nav className="navbar">
      <div className="hamburger" onClick={toggleMenu}>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
      <div className="navbar-logo">
        <img src={logo} alt="VISMA Logo" className="logo" />
        <span className="navbar-title">VISMA</span>
      </div>

      <div ref={menuRef} className={`sliding-menu ${isMenuVisible ? 'visible' : ''}`}>
        <ul>
          <li><a onClick={() => handleNavigate('/')}>Home</a></li>
          <li><a onClick={() => handleNavigate('/research-domains')}>Research Domains</a></li>
          <li><a onClick={() => handleNavigate('/research-projects')}>Research Projects</a></li>
          <li><a onClick={() => handleNavigate('/lab-facilities')}>Laboratory Facilities</a></li>
          <li><a onClick={() => handleNavigate('/collaborations')}>Collaborations</a></li>
          <li><a onClick={() => handleNavigate('/publications')}>Publications</a></li>
          <li><a onClick={() => handleNavigate('/people')}>People</a></li>
          <li><a onClick={() => handleNavigate('/past-scholars')}>Past Scholars</a></li>
          <li><a onClick={() => handleNavigate('/photos')}>Photos</a></li>
          <li><a onClick={() => handleNavigate('/contacts')}>Contact</a></li>
          {user ? (
            <li onClick={handleLogout}>Logout</li> // Show 'Logout' if user is 'admin'
          ) : (
            <li onClick={handleAdminLogin}>Login</li> // Show 'Admin' if user is 'public'
          )}
        </ul>
      </div>

      <ul className="navbar-links">
        <li><a onClick={() => handleNavigate('/')}>Home</a></li>
        <li className="dropdown" ref={dropdownRef} 
            onMouseEnter={handleMouseEnter} 
            onMouseLeave={handleMouseLeave}>
          <a>Research</a>
          {isDropdownVisible && (
            <ul className="dropdown-content">
              <li><a onClick={() => handleNavigate('/research-domains')}>Research Domains</a></li>
              <li><a onClick={() => handleNavigate('/research-projects')}>Research Projects</a></li>
              <li><a onClick={() => handleNavigate('/lab-facilities')}>Laboratory Facilities</a></li>
              <li><a onClick={() => handleNavigate('/collaborations')}>Collaborations</a></li>
            </ul>
          )}
        </li>
        <li><a onClick={() => handleNavigate('/publications')}>Publications</a></li>
        <li><a onClick={() => handleNavigate('/people')}>People</a></li>
        <li><a onClick={() => handleNavigate('/past-scholars')}>Past Scholars</a></li>
        <li><a onClick={() => handleNavigate('/photos')}>Photos</a></li>
        <li><a onClick={() => handleNavigate('/contacts')}>Contact</a></li>
        {user ? (
          <li className="login-logout" onClick={handleLogout}>Logout</li> // Show 'Logout' if user is 'admin'
        ) : (
          <li className="login-logout" onClick={handleAdminLogin}>Login</li> // Show 'Admin' if user is 'public'
        )}
      </ul>
      <div className="navbar-search">
        <i className="fa fa-search" aria-hidden="true"></i>
      </div>
    </nav>
  );
};

export default Navbar;